import { GraphQLClient } from 'graphql-request';

export const gqlClient = (preview?: boolean) =>
  new GraphQLClient(
    `https://graphql.contentful.com/content/v1/spaces/${process.env.REACT_APP_CONTENTFUL_SPACE_ID}/environments/${process.env.REACT_APP_CONTENTFUL_ENVIRONMENT}`,
    {
      headers: {
        Authorization: `Bearer ${
          preview
            ? process.env.REACT_APP_CONTENTFUL_PREVIEW_ACCESS_TOKEN
            : process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN
        }`,
      },
    },
  );
